import { createContext, useContext } from "react";

const ParentStationContext = createContext();
export default ParentStationContext;

export const useParentStation = () => useContext(ParentStationContext);

export function withParentStation(Component) {
  return (props) => {
    return (
      <ParentStationContext.Consumer>
        {(parentStation) => (
          <Component parentStation={parentStation} {...props} />
        )}
      </ParentStationContext.Consumer>
    );
  };
}
